export const asrProxyKeys = {
  all: [{ module: 'asrProxy' }] as const,
  health: () => [{ ...asrProxyKeys.all[0], scope: 'health' }] as const,
  models: () => [{ ...asrProxyKeys.all[0], scope: 'models' }] as const,
  resubmitModelOptions: () => [{ ...asrProxyKeys.all[0], scope: 'resubmitModelOptions' }] as const,
  providerOptions: () => [{ ...asrProxyKeys.all[0], scope: 'providerOptions' }] as const,
  providerLimits: () => [{ ...asrProxyKeys.all[0], scope: 'providerLimits' }] as const,
  settings: () => [{ ...asrProxyKeys.all[0], scope: 'settings' }] as const,
  modelSettings: () => [{ ...asrProxyKeys.all[0], scope: 'modelSettings' }] as const,
  jobsAll: () => [{ ...asrProxyKeys.all[0], scope: 'jobs' }] as const,
  jobs: (search: string) => [{ ...asrProxyKeys.jobsAll()[0], search }] as const,
  transcriptions: () => [{ ...asrProxyKeys.all[0], scope: 'transcription' }] as const,
  transcription: (transcriptionId: string) => [{ ...asrProxyKeys.transcriptions()[0], transcriptionId }] as const,
  providerTranscription: (provider: string, providerTranscriptId: string) =>
    [{ ...asrProxyKeys.all[0], scope: 'providerTranscription', provider, providerTranscriptId }] as const,
};
